<div class="notes-panel">
  <!-- Nuova nota: solo se il ticket non è chiuso né annullato -->
  <div
    class="mb-3"
    *ngIf="canAdd">
    <textarea
      id="integration-note-input"
      pInputTextarea
      class="w-full"
      rows="3"
      [maxlength]="maxNoteLength"
      placeholder="Scrivi una nota da sincronizzare con le integrazioni..."
      [formControl]="newNote"></textarea>
    <div class="flex justify-content-between align-items-center mt-2">
      <small class="grey-text">{{ newNote.value.length }} / {{ maxNoteLength }}</small>
      <p-button
        type="button"
        label="Aggiungi nota"
        icon="pi pi-plus"
        styleClass="butt"
        [rounded]="true"
        [loading]="saving"
        [disabled]="!newNote.value.trim() || newNote.invalid"
        (click)="addNote()"></p-button>
    </div>
  </div>
  <p
    class="grey-text mt-0 mb-3"
    *ngIf="!canAdd">
    Non è possibile aggiungere note: il ticket è chiuso o annullato, o non hai i permessi per
    modificarlo.
  </p>

  <div
    class="text-center py-3"
    *ngIf="loading && !notes.length">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <p
    class="grey-text text-center py-3 my-0"
    *ngIf="!loading && !notes.length">
    Nessuna nota per questo ticket.
  </p>

  <ul class="notes-list">
    <li
      *ngFor="let n of notes"
      class="note">
      <div class="note-meta">
        <strong>{{ authorName(n) }}</strong>
        <span class="grey-text">{{ n.created_on | date: 'dd/MM/yyyy HH:mm' }}</span>
      </div>
      <p class="note-text">{{ n.note }}</p>
      <small
        class="sync-state"
        [class.synced]="n.synced && !n.from_hda"
        [class.from-hda]="n.from_hda">
        <ng-container *ngIf="n.from_hda">
          <i class="pi pi-arrow-circle-down mr-1"></i>Da integrazione
        </ng-container>
        <ng-container *ngIf="!n.from_hda && n.synced">
          <i class="pi pi-check-circle mr-1"></i>Sincronizzata
          <ng-container *ngIf="n.synced_on">
            il {{ n.synced_on | date: 'dd/MM/yyyy HH:mm' }}</ng-container
          >
        </ng-container>
        <ng-container *ngIf="!n.from_hda && !n.synced"
          ><i class="pi pi-clock mr-1"></i>Da sincronizzare</ng-container
        >
      </small>
    </li>
  </ul>

  <div class="flex justify-content-between align-items-center mt-2 gap-2">
    <p-button
      type="button"
      *ngIf="hasMore"
      label="Mostra altre"
      styleClass="butt"
      [outlined]="true"
      [rounded]="true"
      [loading]="loading"
      (click)="loadMore()"></p-button>
    <span *ngIf="!hasMore"></span>
    <a
      class="cursor-pointer text-sm"
      (click)="openAll.emit()"
      >Filtri e storico completo</a
    >
  </div>
</div>
